import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { ModifierCodeService } from 'src/app/services/core/modifier-code/modifier-code.service';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';
import { environment } from 'src/environments/environment';
@UntilDestroy()

@Component({
  selector: 'app-trip-detail-modal',
  templateUrl: './trip-detail-modal.component.html',
  styleUrls: ['./trip-detail-modal.component.css']
})
export class TripDetailModalComponent implements OnInit, AfterViewInit {
  @Output() closeModal = new EventEmitter<any>
  @Input() tripId: any;
  @Input() source: any;
  tripDetail: any;
  appointmentType: any
  member: any;
  spacetypes:any;
  @ViewChild('map') map!: GoogleMap;
  events: any = [];
  fundingSource:any;
  serviceAreas:any;
  levelOfServices:any;
  addons:any;
  preAddons:any
  company:any;
  driver:any;
  vehicle:any;
  directions?: google.maps.DirectionsResult;
  routeVisible = false;
  straightPath: google.maps.LatLngLiteral[] = [];
  preCompanies: any
  status:boolean = true;
  trackinURL:any;
  canRefund:Boolean=false;
  refundAmount: number = 0;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  selectedTransaction: any;
  isRefreshing = false;
  refundReason = ''; 
  submitted = false;
  primaryDiagnosisList:any;
  modifierCodeList: any;
  prePrimaryDiagnosis: any;
  preModifierCodes:any

  constructor(
    private appointmentTypeService: AppointmentTypeService,
    private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private authService: AuthService,
    private fundingSourceService: FundingSourceService,
    private credentialService: CredentialService,
    private serviceArea:ServiceAreasService,
    private levelOfService: LosService,
    private addonService: AddonService,
    private billingService: BillingService,
    private tripService: TripService,
    private paymentsService: PaymentsService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private modifierCodeService: ModifierCodeService,

  ) {
   }

  ngOnInit(): void {

    if(this.source === 'billing'){
      this.getBillingTripById();
    }else if(this.source === 'fundingsourceBilling'){
      this.getFundingSourceBillingTripById();
    }
    else{
      this.getTripById();
    }

    this.trackinURL = environment.TRACKING_URL;
   
  }

  ngAfterViewInit(): void {
    this.fitMapToBounds();
  }

  formatValue(value: any) {

    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }

  async getTripById() {
    const trip = await this.loadTripBasicData();
    if (!trip) return;

    this.getMembersById();
    this.getCredentialCompanies()
    this.getAppointmentById();
    this.getTripEvents();
    this.getSpaceTypes();
    this.getFundingSource();
    this.getAllCompanies();
    this.getPrimaryDiagnosis();
    this.getModifierCodes();
    if (this.tripDetail?.serviceArea) {
      this.getServiceAreas();
    }
    this.getLevelOfService();
    this.getAllAddons()
    this.getDriverById();
    this.getVehicleById();
    setTimeout(() => {
      this.fitMapToBounds();
    }, 0);



  }
  async loadTripBasicData(): Promise<any> {
    this.isRefreshing = true;
    const data = await firstValueFrom(
      this.tripService.getTripById(this.tripId)
    );

    if (!data) {
      this.isRefreshing = false;
      return null;
    }
    this.tripDetail = data;
    if (this.tripDetail?.pickup && this.tripDetail?.destination) {

      this.straightPath = [
        {
          lat: this.tripDetail.pickup.address.coords[1],
          lng: this.tripDetail.pickup.address.coords[0]
        },
        {
          lat: this.tripDetail.destination.address.coords[1],
          lng: this.tripDetail.destination.address.coords[0]
        }
      ];
    }

    this.isRefreshing = false;
    return this.tripDetail;
  }

  getBillingTripById() {
    this.billingService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.tripDetail = data
          if (this.tripDetail?.pickup && this.tripDetail?.destination) {
       
            this.straightPath = [
          {
            lat: this.tripDetail.pickup.address.coords[1],
            lng: this.tripDetail.pickup.address.coords[0]
          },
          {
            lat: this.tripDetail.destination.address.coords[1],
            lng: this.tripDetail.destination.address.coords[0]
          }
        ];
      }

        this.getMembersById();
        this.getAppointmentById();
        this.getTripEvents();
        this.getSpaceTypes();
        this.getModifierCodes();
        this.getPrimaryDiagnosis();
        this.getFundingSource();
        this.getAllCompanies();
        if (this.tripDetail?.serviceArea) {
          this.getServiceAreas();
        }
        this.getLevelOfService();
        this.getAllAddons()
        this.getDriverById();
        this.getVehicleById();
        setTimeout(() => this.fitMapToBounds(), 0);

      }
    })
  }
  getFundingSourceBillingTripById() {
    this.billingService.getFundingSourceTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.tripDetail = data
        this.getMembersById();
        this.getAppointmentById();
        this.getTripEvents();
        this.getSpaceTypes();
        this.getModifierCodes();
        this.getPrimaryDiagnosis();
        this.getFundingSource();
        this.getAllCompanies();
        if (this.tripDetail?.serviceArea) {
            this.getServiceAreas();
          }
        this.getLevelOfService();
        this.getAllAddons()
        this.getDriverById();
        this.getVehicleById();
        setTimeout(() => this.fitMapToBounds(), 0);

      }
    })
  }

  getSortedBreakdown(fare: any, breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };

    return Object.entries(breakdown)
      .flatMap(([key, value]) => {
        // Special case: flatten zone to show only its baseFare
   
        if (
          key.toLowerCase() === 'zone' &&
          value !== null &&
          typeof value === 'object' &&
          'baseFare' in value
        ) {
          return [{
            key: `Zone
            (from ${'from' in value ? value.from : ''} to ${'to' in value ? value.to : ''}mi)`,
            value: value.baseFare,
            unit: '$'
          }];
        }

        return [{
          key: this.formatKey(key),
          value,
          unit: this.getUnit(key, value, fare)
        }];
      })
      .sort((a, b) => {
        const orderA = a.key.replace(/\s+/g, '').toLowerCase() in priority ? priority[a.key.replace(/\s+/g, '').toLowerCase()] : 2;
        const orderB = b.key.replace(/\s+/g, '').toLowerCase() in priority ? priority[b.key.replace(/\s+/g, '').toLowerCase()] : 2;
        return orderA - orderB;
      });
  }

  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, char => char.toUpperCase());
  }

  private getUnit(key: string, value: any, fare: any): string {
    const lowerKey = key.toLowerCase();
    if (value === null) return '';

    // Explicit overrides
    const unitMap: Record<string, string> = {
      distance: 'mi',
      duration: 'min',
      from: 'mi',
      to: 'mi',
    };
    if (unitMap[lowerKey]) return unitMap[lowerKey];

    const moneyLikeKeys = [
      'permilefare',
      'perminfare',
      'total',
      'waittimecharges',
      'pickupsurcharge',
      'extrapassengerfare',
      'additionalpassengers',
      'cancelcharges',
      'noshowcharges',
      'addonfarefixed',
      'addonfarepercentage'
    ];
    if (moneyLikeKeys.includes(lowerKey)) return '$';

    if (fare?.type === 'percentage' ||  lowerKey ==='addonfarediscount' ||  lowerKey ==='addonfarecreditcardfee') return '%';
    if (fare?.type === 'fixed') return '$';

    return '';
  }






  fitMapToBounds() {
    const pickup = this.tripDetail?.pickup?.address?.coords;
    const dropoff = this.tripDetail?.destination?.address?.coords;

    if (!pickup || !dropoff || !this.map || !this.map.googleMap) return;

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(new google.maps.LatLng(pickup[1], pickup[0]));
    bounds.extend(new google.maps.LatLng(dropoff[1], dropoff[0]));

    const gMap = this.map.googleMap;
    if (!gMap) return;

    gMap.fitBounds(bounds, 8);
    const mzoom: any = gMap.getZoom();
    gMap.setZoom(mzoom)
  }

  getServiceAreas() {
    const queryParams = {id: this.tripDetail.serviceArea, isActive: true, limit: 9999 }
    this.serviceArea
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.serviceAreas] = data.results;
        }
      });
    // this.serviceArea.getById(this.tripDetail.serviceArea).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //   if (data) {
    //     this.serviceAreas = data;
    //     }
    //   })
  }

  getDriverById() {
    if (!this.tripDetail.driver) return;
    this.credentialService.getDriverById(this.tripDetail.driver).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.driver = data;
      }
    })
  }

  getVehicleById() {
    if (!this.tripDetail.vehicle) return;
    this.credentialService.getVehicleById(this.tripDetail.vehicle).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vehicle = data;
      }
    })
  }

  getTripEvents() {
    if(this.tripDetail.status === 'scheduled') return;
    let queryParams: any
    if(this.source ==='trips'){
      queryParams = {
        trip: this.tripId
      };
    }else if(this.source ==='billing'){
      queryParams = {
        billing: this.tripId
      };
    } else{
      queryParams = {
        fundingsourceBilling: this.tripId
      };
    }

    this.tripService.getPickerTripEvents(queryParams).pipe(untilDestroyed(this)).subscribe((data:any) => {
           if (data && data.results) {
            this.events = data.results.map((event: any) => ({
        ...event,
        status: event.status
      }));
          console.log("events",this.events);

        }
      })
  }

  getMembersById() {
    const queryParams = {id: this.tripDetail.member, isActive: true, limit: 9999 }
    this.memberService
      .getPickerMembers(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.member] = data.results;
        }
      });
    // this.memberService.getMemberById(this.tripDetail.member).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //     if (data) {
    //       this.member = data;
    //     }
    //   })
  }

  getAppointmentById() {
    const queryParams = {id: this.tripDetail.appointmentType, isActive: true, limit: 9999 }
    this.appointmentTypeService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.appointmentType] = data.results;
        }
      });
    // this.appointmentTypeService.getAppointmentById(this.tripDetail.appointmentType).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //     if (data) {
    //       this.appointmentType = data;
    //     }
    //   })
  }

  getFundingSource() {
    const queryParams = {id: this.tripDetail.fundingsource, isActive: true, limit: 9999 }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.fundingSource] = data.results;
        }
      });
    // console.log(this.tripDetail);
    // this.fundingSourceService.getById(this.tripDetail.fundingsource).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //     if (data) {
    //       this.fundingSource = data;
    //     }
    //   })
  }

  getAllCompanies() {
     if (!this.tripDetail?.company) return;
    const queryParams = { id: this.tripDetail.company, isActive: true, limit: 9999 }
    this.credentialService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.company] = data.results;
        }
      });
  }

  getCredentialCompanies() {
    const queryparams: any = {
      limit: '9999',
      isActive: this.status
    }
    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getSpaceTypes() {
    const queryParams = {id: this.tripDetail.spaceType, isActive: true, limit: 9999 }
    this.spaceTypeService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.spacetypes] = data.results;
        }
      });
    // this.spaceTypeService.getById(this.tripDetail.spaceType).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //     if (data) {
    //       this.spacetypes = data;
    //     }
    //   })
  }

  getLevelOfService() {
    const queryParams = {id: this.tripDetail.levelOfService, isActive: true, limit: 9999 }
    this.levelOfService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.levelOfServices] = data.results;
        }
      });
    // this.levelOfService.getById(this.tripDetail.levelOfService).pipe(untilDestroyed(this)).subscribe((data: any) => {
    //     if (data) {
    //       this.levelOfServices = data;
    //     }
    //   })
  }

  getAllAddons() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.addonService.getPickerAddons(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data.results) {
          this.addons = data.results;
        this.preAddons = this.addons.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  // statusFormat(status: string) {
  //   if (status === 'cancelled') {
  //     return 'cancelled'
  //   }
  //   return status;
  // }
  onCloseModal() {
    this.closeModal.emit();
  }

   breakString(str: any) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }
 loadDirections() {
  if (!this.tripDetail?.pickup || !this.tripDetail?.destination) return;

  const pickup = this.tripDetail.pickup.address.coords;
  const dropoff = this.tripDetail.destination.address.coords;

  const service = new google.maps.DirectionsService();

  service.route(
    {
      origin: { lat: pickup[1], lng: pickup[0] },
      destination: { lat: dropoff[1], lng: dropoff[0] },
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: true // get multiple routes
    },
    (result: any, status) => {
      if (status === 'OK' && this.routeVisible) {
        // 🔹 Pick the shortest route
        let shortestRoute = result.routes[0];
        let minDistance = result.routes[0].legs.reduce(
          (sum: number, leg: any) => sum + leg.distance.value,
          0
        );

        result.routes.forEach((route: any) => {
          const routeDistance = route.legs.reduce(
            (sum: number, leg: any) => sum + leg.distance.value,
            0
          );
          if (routeDistance < minDistance) {
            minDistance = routeDistance;
            shortestRoute = route;
          }
        });

        // Only assign the shortest route
        this.directions = {
          ...result,
          routes: [shortestRoute],
        };
      }
    }
  );
}




toggleRoute(checked: boolean) {
  this.routeVisible = checked;  // Set based on event
  if (this.routeVisible) {
    if (!this.directions) {
      this.loadDirections();
    }
  } else {
    this.fitMapToBounds();
  }
}

  toggleRefund(transaction: any) {

    this.canRefund = true

    this.selectedTransaction = transaction?.squarePaymentId;
    this.refundAmount = this.tripDetail?.payment?.refund ? Math.abs(this.tripDetail?.payment?.refund / 100) : 0

  }
async chargePayment(trip: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to charge payment for this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      this.paymentsService.chargePayment(trip.id).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          if (res) {
            this.getTripById();
            sweetAlert("Alert", "Payment charged successfully", "success", "OK");
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
    }

  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  async refundPayment(trip: any) {
    this.submitted = true;

    if (!this.refundReason || this.refundReason.trim() === '') {
      return;
    }
      const result = await sweetAlert(
      "Alert",
      `Are you sure you want to refund this amount?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      const payload = {
      transactionId: this.selectedTransaction,
      amount: this.refundAmount,
      reason: this.refundReason
      }
      this.paymentsService.refundPayment(trip.id, payload).subscribe((data) => {
      this.loadTripBasicData();
      this.refundAmount=0
      this.selectedTransaction=null
      this.canRefund = false
      sweetAlert("Success", "Amount has been successfully refunded.", "success", "OK");

    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    })
    }
     this.submitted = false;

  }
  async generatePaymentLink(trip: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to generate payment link for this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      this.paymentsService.generatePaymentLink(trip.id).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          if (res) {
            this.getTripById();
            sweetAlert("Alert", "Payment link generated successfully", "success", "OK");
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
    }
  }

  getPrimaryDiagnosis() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.primaryDiagnosisService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.primaryDiagnosisList = data.results;
          this.prePrimaryDiagnosis = this.primaryDiagnosisList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getModifierCodes() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.modifierCodeService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.modifierCodeList = data.results;
          this.preModifierCodes = this.modifierCodeList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  onPaymentVerify() {
    this.paymentsService.verify(this.tripId).pipe(untilDestroyed(this)).subscribe({
      next: (res: any) => {
        // if (res) {
        //   this.getTripById();
        //   sweetAlert("Alert", "Payment verified successfully", "success", "OK");
        // }
      },
      error: (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    });
  }

}
